import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

import Icon from '../Icon/Icon';
import Navbar from '../Navbar/Navbar';
import Tag from '../Tag/Tag';

import useSideNav from './useSideNav';

import styles from './SideNav.module.scss';

const SideNav = () => {
	const {
		state: {
			email,
			fullName,
			imageId,
			role,
			sideNavOpen,
		},
		navigate,
		onLogout,
		toggleSideNav,
	} = useSideNav();

	return (
		<>
			<div className={`${styles.sideNavBackdrop} ${sideNavOpen ? styles.sideNavOpen : ''}`}></div>
			<div className={`${styles.sideNav} ${sideNavOpen ? styles.sideNavOpen : ''}`}>

				<div className={styles.section}>
					<div className={styles.item}>
						<div className={styles.user}>
						{imageId ? 
							<div onClick={toggleSideNav} className={styles.iconContainer}>
								<img alt="" src={imageId} className={styles.avatarImage} /> 
							</div>: 
							<div className={styles.iconContainer}>
								<div className={styles.avatar}>
									<Icon
										color="text"
										height="12px"
										name="user"
										width="12px"
									/>
								</div>
							</div>}

							<div className={styles.info}>
								<div>{fullName || email}</div>
								<Tag color="white">{role}</Tag>
							</div>
						</div>
						<Button onClick={toggleSideNav} type="link">
							<Icon
								color="text"
								height="16px"
								name="times"
								width="16px"
							/>
						</Button>
					</div>
				</div>

				<div className={`${styles.section} ${styles.navbar}`}>
					<div className={styles.iconContainer}></div>
					<Navbar orientation="vertical" onClickItem={toggleSideNav}/>
				</div>
				{role === 'Admin' && <><div className={styles.section}>
					<div className={styles.item}>
						<div className={styles.iconContainer}>
							<Icon
								color="text"
								height="16px"
								name="user-plus"
								width="16px"
							/>
						</div>
						<Button type="link" onClick={navigate.bind(null, '/invite-admin')} style={{ padding: 0 }}>
							<FormattedMessage id="buttons.inviteAdmin" />
						</Button>
					</div>
						<div className={styles.item}>
						<div className={styles.iconContainer}>
							<Icon
								color="text"
								height="16px"
								name="user"
								width="16px"
							/>
						</div>
						<Button type="link" onClick={navigate.bind(null, '/users/admin-profile')} style={{ padding: 0 }}>
							<FormattedMessage id="buttons.myProfile" />
						</Button>
					</div>
					</div>
					</>
				}

				{role !== 'Admin' && <><div className={styles.section}>
					<div className={styles.item}>
						<div className={styles.iconContainer}>
							<Icon
								color="text"
								height="16px"
								name="user"
								width="16px"
							/>
						</div>
						<Button type="link" onClick={navigate.bind(null, '/my-profile')} style={{ padding: 0 }}>
							<FormattedMessage id="buttons.myProfile" />
						</Button>
					</div>

					<div className={styles.item}>
						<div className={styles.iconContainer}>
							<Icon
								color="text"
								height="16px"
								name="settings"
								width="16px"
							/>
						</div>
						<Button type="link" onClick={navigate.bind(null, '/edit-my-profile?tab=settings')} style={{ padding: 0 }}>
							<FormattedMessage id="buttons.settings" />
						</Button>
					</div>
				</div>

				</>}
				<div className={styles.section}>
					<div className={styles.item}>
						<div className={styles.iconContainer}>
							<Icon
								color="text"
								height="16px"
								name="sign-out"
								width="16px"
							/>
						</div>

						<Button type="link" onClick={onLogout} style={{ padding: 0 }}>
							<FormattedMessage id="buttons.logout" />
						</Button>
					</div>
				</div>
			</div>
		</>
	);
}

export default SideNav;